import { fetchVisual } from "lib/visuals/visuals";
import useSWR from "swr";

export const useEmbedVisual = (visual: number, apiKey?: string) => {
  return useSWR(
    ["useEmbedVisual", visual, apiKey],
    () => fetchVisual(visual, undefined, apiKey),
    fetchOptions
  );
};

const fetchOptions = {
  refreshWhenHidden: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  refreshWhenOffline: false,
  shouldRetryOnError: false,
};
